(function() {
  // Add custom code below this line

const selects = document.querySelectorAll('.tag-filter select');
const tagFilters = document.querySelector('.tag-filters');
if (tagFilters) {
  const blogUrl = tagFilters.getAttribute('data-blog');
  console.log(blogUrl);
  selects.forEach(select => {
    select.addEventListener('change', () => {
      const selectedTag = select.options[select.selectedIndex].dataset.tag;
      const filter = select.closest('.tag-filter');

      // Update this filter's data-filter
      filter.setAttribute('data-filter', selectedTag);

      // Collect all active filters
      const allFilters = document.querySelectorAll('.tag-filter');
      const activeTags = [];
      allFilters.forEach(f => {
        const tag = f.getAttribute('data-filter');
        if (tag) activeTags.push(tag);
      });

      // Build new URL
      let newURL = `${blogUrl}/tagged/`;
      if (activeTags.length) {
        newURL += activeTags.join('+');
      } else {
        newURL = `${blogUrl}`;
      }

      // Redirect to the new URL
      window.location.href = newURL;
    });
  });
}


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();